import { render, staticRenderFns } from "./cancel-order.vue?vue&type=template&id=a2b526ac&scoped=true"
import script from "./cancel-order.vue?vue&type=script&lang=js"
export * from "./cancel-order.vue?vue&type=script&lang=js"
import style0 from "./cancel-order.vue?vue&type=style&index=0&id=a2b526ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b526ac",
  null
  
)

export default component.exports